import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import Components
import { ChartWrapperComponent } from './tradingview-wrapper.component';
import { SvgIconModule } from '@toro/common/shared/components';
import { RouterModule } from '@angular/router';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        RouterModule,
        CommonModule,
        SvgIconModule
    ],
    declarations: [
        ChartWrapperComponent
    ],
    exports: [
        ChartWrapperComponent
    ]
})
export class TradingViewModule {}
